import { IGetDfreeBDeviceAnalyticsTraversalRes } from '../../../../types/api/traversal/getDfreeBDeviceAnalytics';

export const defaultData: IGetDfreeBDeviceAnalyticsTraversalRes = {
  residentId: 0,
  careRecords: [],
  results: {
    countLeak: 0,
    countFeces: 0,
    countDayOfFeces: 0,
    countBit: 0,
    countFecesTypes: {
      korokoro: 0,
      hard: 0,
      littleHard: 0,
      middle: 0,
      soft: 0,
      littleSoft: 0,
      water: 0,
      disimpaction: 0,
    },
    countNotifications: {
      success: 0,
      urine: 0,
      failure: 0,
      none: 0,
    },
    countFecesByTerm: {
      day1: 0,
      day2: 0,
      night1: 0,
      night2: 0,
    },
    dailyLaxative: {
      dailyLaxative: [],
    },
    termNotification: {
      minutes: 0,
      count: 0,
    },
  },
};
